module.exports = __webpack_public_path__ + "img/input_bg.d6cc764b.png";